export default __webpack_public_path__ + "static/media/slider-design-1.e63be783.jpg";